// src/keycloak.ts
import type KeycloakFactory from 'keycloak-js';
import environment from './environment';

// Support both ESM default export and CommonJS module shape.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const keycloakModule = require('keycloak-js');

const Keycloak: typeof KeycloakFactory =
  (keycloakModule && keycloakModule.default) || keycloakModule;

const keycloak = new Keycloak({
  url: environment.KEYCLOAK_URL,
  realm: environment.REALM,
  clientId: environment.KEYCLOAK_CLIENT_ID,
});

export default keycloak;
